import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.outer = {
      width: '100%',
      justifyContent: 'center',
      alignItems: ['flex-start', 'center'],
      py: [12, 16],
      px: [0, 11],
      '@media only screen and (max-width: 479px)': {
        py: 8,
      },
    };

    this.innerLeft = {
      variant: 'flex.column',
      width: '100%',
      alignItems: 'flex-start',
    };

    this.innerRight = {
      ...this.innerLeft,
      alignItems: 'flex-end',
    };

    this.innerCenter = {
      ...this.innerLeft,
      alignItems: 'center',
    };

    this.superheading = {
      variant: 'text.label.1',
      mb: 2,
    };

    this.heading = {
      variant: 'text.h2',
      overflowWrap: 'break-word',
    };

    this.bodyWithoutHeading = {
      variant: 'text.base',
      mt: 0,
      ul: {
        ml: 0,
      },
      'p:last-of-type': {
        mb: 0,
      },
    };

    this.bodyWithHeading = {
      ...this.bodyWithoutHeading,
      mt: [10, 11],
    };
  })()
);
